import {Module} from "vuex";
import {RootState} from "@/store/types";
import actions from "@/store/user/actions";
import getters from "@/store/user/getters";
import {State} from "@/store/user/types";
import mutations from "@/store/user/mutations";

const auth: Module<State, RootState> = {
    namespaced: true,
    state: {
        token: localStorage.getItem('token') || '',
        error: '',
        user_info: null,
        user_position: null,
        user_position_bid: null,
        loader: false,
        reset_step: 1
    },
    getters,
    mutations,
    actions
}

export default auth